import { clearAuthPersistence } from '~/lib/authStorage';
export const useLogout = () => {
  clearAuthPersistence();

  useTokens().$reset();
  useUser().$reset();
  useCosmo().$reset();

  navigateTo('/');
}
